import React from 'react';
import DirectoryHero from './DirectoryHero';
import DirectorySearchBar from './DirectorySearchBar';
import TrendingTopics from './TrendingTopics';
import DiscoveryActions from './DiscoveryActions';

function DirectoryHeader({
  spotlightName,
  searchQuery,
  totalCount = 0,
  resultCount = 0,
  recentSearches = [],
  onSearchSubmit,
  onSearchChange,
}) {
  return (
    <section className="relative overflow-hidden border-b border-base-300 text-primary-content">
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-950/35 via-teal-900/22 to-cyan-950/28" aria-hidden="true" />
      <div className="absolute inset-0 bg-[radial-gradient(120%_85%_at_10%_0%,rgba(134,239,172,0.16),rgba(16,24,39,0)_55%),radial-gradient(100%_80%_at_90%_100%,rgba(103,232,249,0.14),rgba(15,23,42,0)_60%)]" aria-hidden="true" />
      <div className="absolute -left-24 -top-20 h-72 w-72 rounded-full bg-emerald-100/10 blur-3xl" aria-hidden="true" />
      <div className="absolute -right-24 -bottom-24 h-80 w-80 rounded-full bg-cyan-100/8 blur-3xl" aria-hidden="true" />

      <div className="relative container mx-auto max-w-7xl px-6 pb-7 pt-6 md:pb-8 md:pt-7">
        <div className="mx-auto w-full max-w-5xl">
          <DirectoryHero
            spotlightName={spotlightName}
            totalCount={totalCount}
          />

          <div className="rounded-2xl border border-white/20 bg-slate-900/30 p-3.5 shadow-[0_10px_35px_rgba(2,6,23,0.28)] backdrop-blur-md">
            <DirectorySearchBar
              spotlightName={spotlightName}
              searchQuery={searchQuery}
              onSearchSubmit={onSearchSubmit}
              onSearchChange={onSearchChange}
            />

            <div className="mt-4 space-y-3">
              <TrendingTopics
                recentSearches={recentSearches}
                onSearchSubmit={onSearchSubmit}
              />

              <div className="flex flex-wrap items-center justify-end gap-2">
                <DiscoveryActions />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DirectoryHeader;